const dotenvVars = require('dotenv').config().parsed;

const BAKED_IN_ENV_VARS = [
  'NODE_ENV',
  'PUBLIC_URL',
  'VERSION',
  'BACKEND_LINK',
  'OTP_BASE_URL',
  'DEFAULT_TOKEN',
  'IDENTITY_APP_KEY',
  'IDENTITY_APP_SECRET',
  'BFF_API_URL'
];

function getAppEnv() {
  const raw = Object.keys(dotenvVars || {}).reduce(
    (env, key) => {
      env[key] = process.env[key];
      return env;
    },
    {
      NODE_ENV: process.env.NODE_ENV,
      PUBLIC_URL: process.env.PUBLIC_URL,
      VERSION: process.env.VERSION,
      BACKEND_LINK: process.env.BACKEND_LINK,
      OTP_BASE_URL: process.env.OTP_BASE_URL,
      DEFAULT_TOKEN: process.env.DEFAULT_TOKEN,
      IDENTITY_APP_KEY: process.env.IDENTITY_APP_KEY,
      IDENTITY_APP_SECRET: process.env.IDENTITY_APP_SECRET,
      BFF_API_URL:process.env.BFF_API_URL
    }
  );

  const forWebpackDefinePlugin = {
    'process.env': Object.keys(raw).reduce((env, key) => {
      if (BAKED_IN_ENV_VARS.includes(key)) {
        env[key] = JSON.stringify(raw[key]);
      } else {
        env[key] = `process.env.${key}`;
      }
      return env;
    }, {})
  };

  const forIndexHtml = JSON.stringify({
    env: raw
  });

  return { raw, forIndexHtml, forWebpackDefinePlugin };
}

module.exports = {
  getAppEnv
};
